import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../services/api';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const authContext = useAuth();
  console.log("Login Component: AuthContext:", authContext);
  const { login, directLogin, isTestMode } = authContext;

  const handleLogin = async () => {
    console.log("Login Component: handleLogin started.");
    try {
      console.log("Login Component: Checking isTestMode:", isTestMode);
      if (isTestMode) {
        console.log("Login Component: Test mode detected.");
        // In test mode, use the test login endpoint
        const response = await api.get('/auth/test/login');
        const { user } = response.data;
        
        // Save only user data - tokens are handled as cookies
        localStorage.setItem('user', JSON.stringify(user));
        
        // Update authentication state
        directLogin(1); // Default to user 1 in test mode
        
        // Navigate to myshifts
        navigate('/myshifts');
      } else {
        console.log("Login Component: Production mode detected. Calling login function from context...");
        // Ensure the login function is actually called
        login();
        console.log("Login Component: login() function called.");
      }
    } catch (error) {
      console.error('Login Component: handleLogin error:', error);
      alert('Login failed. Please try again.');
    }
  };

  // Function to login as a specific user by ID (test mode only)
  const loginAsUser = (userId: number) => {
    directLogin(userId);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>
        <div className="mt-8 space-y-6">
          <button
            onClick={handleLogin}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Sign in
          </button>
          
          {isTestMode && (
            <div className="mt-4">
              <h3 className="text-lg font-medium text-gray-900">Development Quick Login</h3>
              <div className="mt-2 space-y-2">
                <button
                  onClick={() => loginAsUser(1)}
                  className="w-full px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 rounded"
                >
                  Login as User 1
                </button>
                <button
                  onClick={() => loginAsUser(2)}
                  className="w-full px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 rounded"
                >
                  Login as User 2
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login; 